import mobileAdjustment from "../GeneralMobileAdjustments";
import listService from "../../../service/ListService";
import $ from "jquery";
import mobileListService from "../../../service/mobile/MobileListService";

class MobileGroupControlView {

    constructor() {}

    afterRender(control) {

        $(document).on('dragstart', '.pf-control', function(event) {
            event.preventDefault(); 
            return false;           // Ensure jQuery UI gets the mousedown
        });
        
        let element = mobileAdjustment.adjustMobileControl(control);
        if(element){
            let controlContainer = element.parent();
            controlContainer.css('height', 'auto');
            element.css({'height': 'auto'});

            let groupItems = element.find('[id^=\'groupItems\']');
            let itemsContainer = Array.from(groupItems.children());

            listService._mobileObjects
                .filter(control => control.groupId === controlContainer[0].id)
                .sort((e1, e2) => e1.tabIndex - e2.tabIndex)
                .map(e1 => { return { id: e1.id, tabIndex: e1.tabIndex }})
                .toArray()
                .forEach(control => {
                    let el = itemsContainer.find(child => child.id === control.id);
                    el.tabIndex = control.tabIndex;
                    groupItems.append(el);
                });

            this.createDraggable(groupItems);
        }
    }

    createDraggable(element) {
         $(element).sortable({
            containment: "#" + element[0].id,
            placeholder: 'mobile-control-placeholder',
            cursorAt: { top: 5},
            tolerance: "pointer",
            dropOnEmpty: true,
            items: element.children(),
            start: function(event, ui) {
                ui.item.toggleClass("mobile-control-placeholder");
            },
            stop: function(event, ui) {
                ui.item.toggleClass("mobile-control-placeholder");

                const groupId = ui.item[0].parentElement.id.substr(10);
                const siblings = Array.from(ui.item[0].parentElement.children);

                const mobileObjects = listService._mobileObjects
                    .filter(control => control.groupId === groupId)
                    .toArray();

                const mobileMap = mobileListService._mobileObjMap
                    .filter(control => control._groupId === groupId)
                    .toArray();

                siblings.forEach((elem, index) => {
                    const newIndex = (index + 1);
                    const mobileObj = mobileObjects.find(o => o.id === elem.id);
                    mobileObj.tabIndex = newIndex;

                    const mobileControl = mobileMap.find(o => o.model.get('id') === elem.id);
                    mobileControl.model.set('tabIndex', newIndex, {silent: true});
                });
            }
        });

        //$(".pf-section-control").disableSelection();
    }
}

const mobileGroupControlView = new MobileGroupControlView();
export default mobileGroupControlView;